import React, { Component } from 'react';
import {Field, formValueSelector, reduxForm} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from '../components/CustomAlert.js';
import RenderField from "./RenderField";
import StatesList from '../containers/StatesContainer.js';
import CustomAutosuggestMobileFriendly from "./CustomAutosuggestMobileFriendly";
import {connect} from "react-redux";


class AdditionalCompanyInformation extends Component {

    constructor(props) {
        super(props);
        this.state = {};

    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const reason_financial_aid = [{id: 0, name: 'Solventar gastos ocasionados por enfermedades'},{id: 1, name: 'Adquirir elementos de estudio'},{id: 2, name: 'Pagar viajes de turismo, de estudio y prácticas deportivas'},{id: 3, name: 'Adquirir la vivienda propia, efectuar ampliaciones o mejoras y gastos de escrituración'},{id: 4, name: 'Adquirir bienes muebles, y/o automotores'},{id: 5, name: 'Mantenimiento o formación de un capital de trabajo'},{id: 6, name: 'Otros'}];

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_additional_company_information" defaultMessage={"Informacion Adicional"}  description="Additional Company info"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveAdditionalCompanyInformation)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-md-4 col-lg-4">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_area_code" autoComplete="off" component={RenderField} type={'number'} label="Código de Area" />
                                    </div>
                                </div>
                                <div className="col-md-8 col-lg-8">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_number" autoComplete="off" component={RenderField} type={'number'} label="Número de Celular" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_seniority_years" autoComplete="off" component={RenderField} type={'number'} label="Antigüedad Laboral actual (años)" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="net_income" autoComplete="off" component={RenderField} type={'currency'} label="Ingreso mensual neto" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

AdditionalCompanyInformation.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([
    {name: 'work_area_code', required: true},
    {name: 'work_number', required: true},
    {name: 'work_seniority_years', required: true},
    {name: 'net_income', required: true},
]);

AdditionalCompanyInformation = TopScrolleable(AdditionalCompanyInformation);

AdditionalCompanyInformation = reduxForm({
    form: 'AdditionalCompanyInformation', // a unique name for this form
    validate
})(AdditionalCompanyInformation);

AdditionalCompanyInformation = withAuthControl(AdditionalCompanyInformation);

export default AdditionalCompanyInformation;


/** WEBPACK FOOTER **
 ** ./src/components/AdditionalCompanyInformation.js
 **/